<template>
    <div> 
        <base-header type="" class="rsgradient pb-3 pb-1 pt-3 pt-md-5">
        </base-header>
         <b-card style="margin: 20px">
             <b-card-header header-tag="header" class="p-1" role="tab">
                Validación de DNI
            </b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Hola! Necesitamos validar tu DNI. Favor de completar los campos a continuación para poder realizarlo.</label> 
                    </div>
                </div>   
                
                <div class="row form-group" >
                    <div class="col-md-12">
                        <DocumentComponent
                            :Title="Renaper"
                            @saveValue="saveValue"
                            @setErrors="setErrors"
                        ></DocumentComponent>
                    </div>
                </div>  
                
                <div class="row form-group" >
                    <div class="col-md-12">
                        <save-button text="Continuar" @click="continuar"></save-button>
                    </div>
                </div>
            </b-card-body>
        </b-card> 
    </div>
</template>

<style>
</style>

<script>
    import Vue from 'vue'
    import vSelect from 'vue-select'
    Vue.component('v-select', vSelect)
    import 'vue-select/dist/vue-select.css';
    import axiosHelpers from '@/helpers/axiosHelpers';
    import notificationHelpers from '@/helpers/notificationHelpers';
    import DocumentComponent from "@/components/FormsRequirementTypes/DocumentComponent";

    export default {
        components: { 
            DocumentComponent
        },
        data(){
            return{
                model: { 
                    Continuar: false       
                },
                Errors: []
            }
        },
        methods: {
            continuar() {
                let context = this;
                if (context.Errors.length == 0) 
                {
                    notificationHelpers.showError("Alerta!", context.Errors[0], context);
                    return false;
                }
                else
                {
                    context.$router.push("dashboard");
                }
            },
            setErrors(errors) {
                let context = this;
                context.Errors = errors;
            },
            saveValue(value) {
                let context = this;
                context.model.Continuar = true;
            },
        }
    }
</script>